import debug from 'debug';

export const getLogger = (ns: string) => {
	const logger = debug(ns);
	return (...args: any[]) => {
		return logger(ns, ...args);
	};
};